import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import store from '../store'

Vue.use(Vuetify);

let themeColor = store.getters.themeColor;
let themeSite = store.getters.themeSite;

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
          },
        themes: {
          light: {
            default_primary: themeSite.primary_color || '#2D4E9A',
            primary_exam: themeColor.primary_exam || '#2D4E9A',
            background_primary: themeColor.background_primary_color || '#F7F8FA',
            header_text: '#333333',
            background_head: '#F5F5F5',
            title_confirm_dialog: '#212121',
            null_text_table: '#BDBDBD',
            button_disable_light: '#E0E0E0',
            button_disable_text: '#999999',
            text_shade: '#757575',
            success: '#58A144',
            error: '#D1392B',
            highlight_button: '#EAEFFA',
          },
          dark: {
          },
        },
      },
});
